import { connect } from 'react-redux';
import { getIsVerified } from 'ha/modules/AuthLogic/selectors';
import { GlobalState } from 'ha/types/store';
import ListYourPlaceCTA from '../components/ListYourPlaceCTA';

export default connect((state: GlobalState) => ({
  isVerified: getIsVerified(state),
}))(ListYourPlaceCTA);
